import React from 'react';

const UserIcon = ({ color = 'var(--icon-default)', width = 20, height = 21, strokeWidth = 1.25, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <circle cx="10.0013" cy="5.5013" r="3.33333" stroke={color} strokeWidth={strokeWidth} />
      <path
        d="M16.6654 15.082C16.6654 17.1531 16.6654 18.832 9.9987 18.832C3.33203 18.832 3.33203 17.1531 3.33203 15.082C3.33203 13.011 6.3168 11.332 9.9987 11.332C13.6806 11.332 16.6654 13.011 16.6654 15.082Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default React.forwardRef(UserIcon);
